export default __webpack_public_path__ + "img/custom-screens-charts.d047f435.png";